import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, fmtDate, inr } from "@/lib/api";
import { DataTable, Money, PageHeader } from "@/components/common";

const BUCKETS = ["current", "1-30", "31-60", "61-90", "90+"];
const BUCKET_LABELS = { current: "Current", "1-30": "1–30 days", "31-60": "31–60 days", "61-90": "61–90 days", "90+": "90+ days" };

export default function Receivables() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/reports/receivables").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return <div className="py-24 text-center"><Loader2 className="h-6 w-6 animate-spin inline text-[#5C6B69]" /></div>;
  return (
    <div data-testid="receivables-page">
      <PageHeader title="Accounts Receivable" subtitle={`Total outstanding: ${inr(data.totals.outstanding)}`} testid="receivables-header" />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        {BUCKETS.map((b) => (
          <div key={b} className="bg-white border border-[#E5E0D8] rounded-xl p-4 shadow-sm" data-testid={`aging-${b}`}>
            <div className="text-xs font-semibold uppercase tracking-wide text-[#5C6B69]">{BUCKET_LABELS[b]}</div>
            <div className={`num text-xl font-bold mt-1 ${b === "90+" ? "text-red-600" : "text-[#0D4F4A]"}`}>{inr(data.aging[b] || 0)}</div>
          </div>
        ))}
      </div>
      <DataTable testid="receivables-table"
        columns={[
          { key: "customer", label: "Customer", render: (r) => <span className="font-medium">{r.customer}</span> },
          { key: "invoice_no", label: "Invoice", render: (r) => <span className="text-[#0D4F4A] font-semibold">{r.invoice_no}</span> },
          { key: "date", label: "Invoice Date", render: (r) => fmtDate(r.date) },
          { key: "due_date", label: "Due Date", render: (r) => fmtDate(r.due_date) },
          { key: "amount", label: "Amount", align: "right", render: (r) => <Money value={r.amount} /> },
          { key: "paid", label: "Paid", align: "right", render: (r) => <Money value={r.paid} /> },
          { key: "balance", label: "Balance", align: "right", render: (r) => <Money value={r.balance} className="font-semibold text-red-600" /> },
          { key: "days", label: "Days", align: "right", render: (r) => (
            <span className={`num ${r.days > 30 ? "text-red-600 font-bold" : ""}`}>{r.days}</span>) },
          { key: "bucket", label: "Aging", render: (r) => (
            <span className="text-xs font-semibold bg-[#FAF8F5] border border-[#E5E0D8] rounded-full px-2 py-0.5">{BUCKET_LABELS[r.bucket]}</span>) },
        ]}
        rows={data.rows} onRow={(r) => navigate(`/invoices/${r.invoice_id}`)}
        empty="No outstanding receivables. All collected!" />
    </div>
  );
}
